import { getVisitorId, trackHeapEvent } from '@ratehub/base-ui';


/**
 * 'CC Web Click'-specific call to `trackHeapEvent`.
 * @param {CreditCardShape} cardInfo
 * @param {string} cardInfo.detailsURL
 * @param {string} cardInfo.bank
 * @param {boolean} cardInfo.isMonetized
 * @param {boolean} cardInfo.isSponsored
 * @param {boolean} [trackHotJarSurvey=false] - Whether to trigger a HotJar survey event.
 */
function trackHeapEventCCWebClick({ detailsURL, bank, isMonetized, isSponsored }, trackHotJarSurvey = false) {
    trackHeapEvent('CC Web Click', {
        href: detailsURL,
        provider: bank,
        monetized: isMonetized.toString(),
        sponsored: isSponsored.toString(),
    });

    if (trackHotJarSurvey) {
        if (typeof window?.hj === 'undefined') {
            return;
        }

        const visitorId = getVisitorId();

        window.hj('event', 'cc_web_click', {
            href: detailsURL,
            provider: bank,
            monetized: isMonetized.toString(),
            sponsored: isSponsored.toString(),
            visitorId,
        });
    }
}

export default trackHeapEventCCWebClick;
